import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import moment from "moment";

const ViewPurchaseOrder = () => {
    const { id } = useParams();
    const [purchaseOrder, setPurchaseOrder] = useState({
        purchase_order_number: "",
        prefix: "",
        date: "",
        supplier: {
            name: ""
        },
        total_qty: "",
        remarks: ""
    });

    const getPurchaseOrder = () => {
        axios.post(API_URL.PURCHASE_ORDER_GET, { id: id }).then((res) => {
            if (res.data.status === 1) {
                setPurchaseOrder(res.data.data);
            }
        });
    }

    const printPurchaseOrder = () => {
        window.print();
    }

    useEffect(() => {
        getPurchaseOrder();
    }, [id])
    return (
        <>
            <div className="row hidden-print">
                <div className="col-6">
                    <h1>Purchase Order</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center justify-content-end">
                        <button className="btn btn-dark mr-2" onClick={() => printPurchaseOrder()}>
                            <i className="fa fa-print me-2" aria-hidden="true"></i> Print
                        </button>
                        <Link to={"/purchase-order"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <table className="table table-bordered" style={{ fontSize: 14 }}>
                            <thead>
                                <tr>
                                    <th colSpan={2}>
                                        <span style={{ fontSize: 18 }}>{purchaseOrder?.supplier?.name}</span>
                                        <br />
                                        PO. No. : {purchaseOrder?.prefix}/{purchaseOrder?.purchase_order_number}
                                    </th>
                                    <th colSpan={2} className="text-right">Date : {moment(purchaseOrder?.created_at).format('DD/MM/YYYY')}
                                        <br />
                                        Total Qty : {purchaseOrder?.total_qty}
                                    </th>
                                </tr>
                                <tr>
                                    <th className="text-center" width="50">#</th>
                                    <th>Product</th>
                                    <th className="text-center" width="100">Qty</th>
                                    <th width="120">Image</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchaseOrder?.items?.map((item, key) => {
                                    return (
                                        <tr key={key}>
                                            <td className="text-center">{key + 1}</td>
                                            <td> 
                                                <strong>Name : {item?.product?.name} { item?.subproduct?.name ? " - " + item?.subproduct?.name : "" }</strong>
                                                <br />
                                                Size : {(item?.subproduct && item?.subproduct?.size) ? item?.subproduct?.size?.name : item?.product?.size?.name }
                                                <br />
                                                Series : {item?.series?.toString()}
                                            </td>
                                            <td className="text-center" style={{ fontSize: 16, verticalAlign: 'middle' }}><strong>{item?.qty} {item?.product?.unit}</strong></td>
                                            <td>
                                                <img style={{ width: 100, height: 100 }} src={item?.image_url} alt={item?.product?.name} />
                                            </td>
                                        </tr>
                                    )
                                })}
                                {purchaseOrder?.remarks && (
                                    <tr>
                                        <th colSpan={4} className="text-danger">Remarks : {purchaseOrder?.remarks}</th>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewPurchaseOrder;